import routesMatch from 'rise-ui/utils/routes-match.js';

export default function routeInfoOfName(routeInfo, name) {
  const matchRoute = name => routesMatch(routeInfo.name, name);
  let result;
  while (!result && routeInfo) {
    if ([].concat(name || []).some(matchRoute)) {
      result = routeInfo;
    } else {
      routeInfo = routeInfo.parent;
    }
  }
  return result;
}
